import { useEffect, useState } from "react"

interface GeorisquesData {
  risquesNaturels?: Record<string, { libelle?: string; present?: boolean }>
  risquesTechnologiques?: Record<string, { libelle?: string; present?: boolean }>
  url?: string
}

const georisquesCache = new Map<string, GeorisquesData>()

export function useGeorisques(center: [number, number] | null) {
  const [data, setData] = useState<GeorisquesData | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const lon = center?.[0] ?? null
  const lat = center?.[1] ?? null

  useEffect(() => {
    if (lon === null || lat === null) {
      setData(null)
      setLoading(false)
      setError(null)
      return
    }

    const cacheKey = `${lon},${lat}`
    const cached = georisquesCache.get(cacheKey)
    if (cached) {
      setData(cached)
      setLoading(false)
      return
    }

    setLoading(true)
    setError(null)

    fetch(`https://georisques.gouv.fr/api/v1/resultats_rapport_risque?latlon=${lon}%2C${lat}`)
      .then((res) => {
        if (!res.ok) throw new Error(`Georisques API error: ${res.status}`)
        return res.json()
      })
      .then((json) => {
        georisquesCache.set(cacheKey, json)
        setData(json)
        setLoading(false)
      })
      .catch((err) => {
        setError(err.message)
        setLoading(false)
      })
  }, [lon, lat])

  return { data, loading, error }
}
